import Fab from '@material-ui/core/Fab';
import PauseIcon from '@material-ui/icons/Pause';
import PlayIcon from '@material-ui/icons/PlayArrow';
import React, { PureComponent } from 'react';
import ReactPlayer from 'react-player';
import { connect } from 'unistore/full/react';
import actions from './actions';
import './MediaObject.scss';

const START_PREVIEW_AT_SECONDS = 0;
const END_PREVIEW_AT_SECONDS = 10;

// FIXME: hasFocus show button & background
export default connect(
  (
    { preview: { uri: previewUri, fileUri, isPlaying, key: previewKey } },
    { uri }
  ) => ({
    isPlaying: previewUri === uri && isPlaying,
    fileUri: previewUri === uri && fileUri,
    previewKey,
  }),
  actions
)(
  class MediaObject extends PureComponent {
    state = {
      previewPlayedFraction: 0,
    };

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.fileUri && !this.props.fileUri)
        this.setState({ previewPlayedFraction: 0 });
    }

    onProgress = ({ played, playedSeconds, loadedSeconds }) => {
      if (this.props.isPlaying)
        this.setState({
          previewPlayedFraction:
            playedSeconds / (END_PREVIEW_AT_SECONDS || loadedSeconds),
        });
    };

    onEnded = () => {
      this.props.pausePreview();
      this.setState(() => ({ previewPlayedFraction: 0 }));
    };

    onPause = () => {
      this.props.pausePreview();
      this.setState(() => ({ previewPlayedFraction: 0 }));
    };

    render() {
      const {
        uri,
        imageUrl,
        fileUri,
        isPlaying,
        isMuted,
        previewKey,
        className = '',
      } = this.props;
      const { previewPlayedFraction } = this.state;
      return (
        <div
          className={`MediaObject ${
            isPlaying ? 'MediaObject--is-playing' : ''
          } ${className} MediaObject--touch`}
        >
          <div
            className="MediaObject__background"
            style={{
              backgroundImage: imageUrl && `url(${imageUrl})`,
            }}
          />
          {fileUri && (
            <>
              <ReactPlayer
                key={previewKey}
                url={
                  fileUri +
                  (START_PREVIEW_AT_SECONDS || END_PREVIEW_AT_SECONDS
                    ? `#t=${START_PREVIEW_AT_SECONDS},${END_PREVIEW_AT_SECONDS}`
                    : '')
                }
                playing={isPlaying}
                onProgress={this.onProgress}
                onEnded={this.onEnded}
                onPause={this.onPause}
                progressInterval={16}
                width="0"
                height="0"
                playsinline
                config={{ file: { forceAudio: true } }}
                muted={isMuted}
                volume={0.01}
              />
              <svg
                className="MediaObject__play-progress-circle"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="40px"
                height="40px"
                viewBox="0 0 40 40"
                style={{ position: 'absolute' }}
              >
                <circle
                  cx="20"
                  cy="20"
                  r="18"
                  fill="transparent"
                  stroke="white"
                  strokeWidth="2"
                  strokeDasharray="113"
                  style={{
                    strokeDashoffset:
                      113 - (isPlaying ? previewPlayedFraction : 0) * 113,
                    transition: isPlaying
                      ? 'none'
                      : 'stroke-dashoffset 0.3s ease-in-out',
                  }}
                  transform="rotate(-90, 20, 20)"
                />
              </svg>
            </>
          )}
          <Fab
            color="default"
            aria-label="Add"
            size="small"
            className="MediaObject__play-button"
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              if (isPlaying) this.props.pausePreview(uri);
              else this.props.playPreview(uri);
            }}
            onMouseDown={(event) => event.stopPropagation()}
            disableRipple
          >
            {isPlaying ? <PauseIcon /> : <PlayIcon />}
          </Fab>
        </div>
      );
    }
  }
);
